import { AuthRepository } from "../api";
import { setAuthAction  } from "../actions";
import { Auth  } from "../models";

export default class AuthMiddleware {
	constructor(store) {
		this.store = store;
		this.authRepo = new AuthRepository();

		this.authorize = this.authorize.bind(this);
	}

	async authorize(nextState, replace, cb) {
		const token = window.sessionStorage.getItem("session_token") || window.localStorage.getItem("session_token");

		if(!token) {
			replace("/");
			return cb();
		}

		const promise = await this.authRepo.validateToken(token);

		if(promise.error) {
			window.localStorage.removeItem("session_token");
			window.sessionStorage.removeItem("session_token");
			replace("/");
			return cb();		
		}

		this.store.dispatch(setAuthAction(new Auth(promise.data)));
		cb();
	}
}


// WEBPACK FOOTER //
// src/middlewares/AuthMiddleware.js